import React from 'react';
import { translate } from 'react-i18next';

import {Button, Form, Input, Grid, Header, Message, Label, Segment, Modal} from 'semantic-ui-react';

import Utils from 'utils/Utils.js';
import {colors, shadow, spacings, fonts, buttons} from 'style';
import styleDef from './style.js';
var style = {
    ...styleDef,
    header: {
        color: colors.themeTeal,
        textAlign: 'center',
        borderBottom: 'none',
        paddingTop: spacings.base,
        paddingBottom: '0',
        ...fonts.bodyL,
    },
    content: {
        textAlign: 'center',
        padding: '0',
    },
    description: {
        margin: spacings.base
    },
    button: {
        ...buttons.short,
        display: 'block',
        marginTop: spacings.base,
        marginBottom: spacings.base,
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    cancelButton: {
        backgroundColor: '#fff',
        color: colors.themeDarkGrey,
    }
};

const ConfirmGroupSwitch = ({t,
                         onConfirm, 
                         onClose}) => (
        <Modal closeIcon open size="mini" onClose={onClose}>
        <Modal.Header style={style.header}>{t('confirm_switch')}</Modal.Header>
        <Modal.Content style={style.content}>
            <div style={style.description}>
                {Utils.endlToBr(t('confirm_group_switch_message'))}
            </div>
            <Button style={style.button} onClick={onConfirm}>{t('Switch Now')}</Button>
            <Button style={{...style.button, ...style.cancelButton}} onClick={onClose}>{t('Cancel')}</Button>
        </Modal.Content>
      </Modal>
  );

export default translate('authentication')(ConfirmGroupSwitch);



// WEBPACK FOOTER //
// ./src/modules/authentication/ConfirmGroupSwitch.js